var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.media)?_c('div',{staticClass:"list_row"},[_c('span',{staticClass:"label_title"},[_c('strong',[_vm._v(" "+_vm._s(_vm.value.label)+": ")])]),_vm._v(" "),_c('span',{staticClass:"label_content file_content",on:{"click":_vm.downloadFile}},[_vm._v("\n        "+_vm._s(_vm.media && _vm.media.name)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }